import {RetentionBookmarkParams} from 'common/report/retention/util/types';
import {SuccessResponse} from 'common/report/retention/models/types';
import {getQueryType} from 'common/report/retention/util/request';
import {RetentionQuery} from 'common/report/retention/models/retention-query';
import {REPORT_LIMITS, ReportName} from 'common/report/constants';
import {isAddiction} from 'common/report/retention/util';
import {API_CHART_TYPE_TO_COMMON_CHART_TYPE} from 'common/report/retention/util/constants';

import {QueryManager} from '../report-manager/query';
import {BaseQueryErrorType} from '../types';

export class RetentionQueryManager extends QueryManager<RetentionBookmarkParams, SuccessResponse, BaseQueryErrorType> {
  public reportName = ReportName.Retention;
  public endpoint = `retention`;

  protected getEndpoint(bookmarkParams: RetentionBookmarkParams): string {
    return isAddiction(bookmarkParams) ? `retention/frequency` : `retention`;
  }

  public getExtraPostParams(bookmarkParams: RetentionBookmarkParams) {
    const model = RetentionQuery.createFromBookmark(bookmarkParams);
    return {
      bookmark: {
        ...bookmarkParams,
        limit: REPORT_LIMITS[ReportName.Retention].query,
      },
      query_type: getQueryType(API_CHART_TYPE_TO_COMMON_CHART_TYPE[bookmarkParams.chart_type]),
      project_id: String(this.projectId),
      use_query_sampling: model.querySampling,
      client_version: 4,
      ...(this.workspaceId ? {workspace_id: this.workspaceId} : {}),
    };
  }

  public getExtraCsvPostParams(bookmarkParams: RetentionBookmarkParams) {
    const model = RetentionQuery.createFromBookmark(bookmarkParams);
    return {
      bookmark: {
        ...bookmarkParams,
        limit: REPORT_LIMITS[ReportName.Retention].csvExport,
      },
      query_type: getQueryType(API_CHART_TYPE_TO_COMMON_CHART_TYPE[bookmarkParams.chart_type]),
      project_id: String(this.projectId),
      use_query_sampling: model.querySampling,
      client_version: 4,
      ...(this.workspaceId ? {workspace_id: this.workspaceId} : {}),
    };
  }

  public transformBookmarkParams(bookmarkParams: RetentionBookmarkParams) {
    return bookmarkParams;
  }
}
